import { render, staticRenderFns } from "./a-button.vue?vue&type=template&id=e0e9c926&"
import script from "./a-button.vue?vue&type=script&lang=js&"
export * from "./a-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports